import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installVisualAcceptanceDiagnostics } from "./visualAcceptanceRuntime";
import "./styles.css";
import "./task-engine.css";

installVisualAcceptanceDiagnostics();

const PRELOAD_RECOVERY_KEY = "history-sim:last-preload-recovery";

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  const lastRecovery = Number.parseInt(sessionStorage.getItem(PRELOAD_RECOVERY_KEY) ?? "0", 10);
  const now = Date.now();

  if (now - lastRecovery > 15_000) {
    sessionStorage.setItem(PRELOAD_RECOVERY_KEY, String(now));
    window.location.reload();
  }
});

const root = document.getElementById("root");

if (!root) {
  throw new Error("The application root element is missing.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
